export default __webpack_public_path__ + "files/algae-bloom-f69440ceee739a67e75850fd8f8cd278.jpg";